import apiAgent from "../../api/apiAgent";
import { useEffect, useState } from "react";
import { PageContainer, PageContent } from "../../components/PageContainer";
import { Link, redirect, useNavigate, useParams } from "react-router-dom";
import { BreadCrumbs, TitleBar } from "../../components/TitleBar";
import { AddButton, Button } from "../../components/Button";
import { ItemList } from "../../components/Lists/ItemLists";
import _ from "lodash";
import {
  SortMenu,
  defaultSortFields,
  useSortState,
} from "../../components/SortMenu";
import { useValidateModel } from "../../atoms";
import { tMsg } from "../../components/ToastNotifications";
import { checkTitle } from "../../utils";
import {
  IndexPublishSection,
  PublishBannerByModel,
} from "../../components/Publishing";
import { publishGroups } from "../../components/Publishing/publishConfig";

const BaseItemIndex = (): JSX.Element => {
  const params = useParams();
  const navigate = useNavigate();
  const modelName = params.model?.toString() || "unknown";
  useValidateModel(modelName);

  const [data, setData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [sortState, setSortState] = useSortState(defaultSortFields[0]);
  const [refresh, setRefresh] = useState<boolean>(true);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const endpoint = `${modelName}?sort_by=${sortState.field}&sort_dir=${sortState.order}`;
      const response = await apiAgent.DataType.getAll(endpoint);
      setData(response.data);
    } catch (err) {
      console.log(err);
      tMsg.error("Error retrieving data");
      navigate("/m/error"); // TODO: put this back after debugging
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [modelName, sortState, refresh]);

  return (
    <PageContainer isLoading={isLoading}>
      <PageContent>
        <BreadCrumbs crumbs={[]} />
        <TitleBar title={checkTitle(modelName)}>
          <Link to={"create"}>
            <AddButton />
          </Link>
        </TitleBar>
        {/* <SortMenu
          modelName={modelName}
          fields={defaultSortFields}
          modifySortState={setSortState}
          sortState={sortState}
        /> */}
        <PublishBannerByModel modelName={modelName} />
        <ItemList
          data={data}
          modelName={modelName}
          refreshList={() => setRefresh(!refresh)}
        />
      </PageContent>
    </PageContainer>
  );
};

export default BaseItemIndex;
